var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-body position-relative p-0 mt-3",
      attrs: { id: "collaborators-select-container" },
    },
    [
      !_vm.emptyCollaborators
        ? _c("div", { staticClass: "w-100" }, [
            _c(
              "div",
              { staticClass: "form-group-material" },
              [
                _c("select2", {
                  ref: "select",
                  attrs: {
                    id: "collaborators-select",
                    data: _vm.collaborators,
                    value: _vm.value,
                    name: "collaborators-select",
                    multi: "",
                    options: _vm.options,
                    "format-data": _vm.formatData,
                    "init-on-mounted": true,
                    multiple: "",
                  },
                  on: { change: _vm.handleChange },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "bar" }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "title text-light-gray mb-2 mb-lg-0" },
                  [_vm._v(_vm._s(_vm.$t("boards.actions.addOrRemoveAgents")))]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }